import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';


function hasAccessToRoute(routePath) {
    const rotasPermitidas = JSON.parse(localStorage.getItem('rotasPermitidas') || '[]');
    return rotasPermitidas.includes(routePath);
}

const ProtectedRoute = ({ element, path }) => {
    const location = useLocation();

    if (!hasAccessToRoute(path || location.pathname)) {
        return <Navigate to="/" replace />;
    }
    return element;
};

export default ProtectedRoute;